import { EnvironmentHeritageLeftMenuList } from "../utils/constants";
import { TableStructure } from "../components/TableStructure";

const List = [
  {
    fileStoreId: "532cbc78-4492-440a-9e4f-b1a45b5a71fe",
    label:
      "Graded List of Heritage Buildings Grade-I, Grade-IIA & Grade-IIB premises as on 25/02/2009",
  },
];

const Heritage_Heritage_Buildings = () => (
  <TableStructure
    title="Heritage Buildings"
    heading={"List of Heritage Buildings"}
    list={List}
    columnNo={1}
    leftMenuList={EnvironmentHeritageLeftMenuList}
    longMenuList={true}
  />
);

export default Heritage_Heritage_Buildings;
